import { useEffect, useRef, useState } from "react";
import { alertService } from "client-app-core";
import { isAlertReferencePrefix } from "./utils";

const SEARCH_DEBOUNCE_MS = 250;

const useAlertReferenceSearch = ({ value, closed, enabled = true }) => {
	const [results, setResults] = useState(null);
	const [isSearching, setIsSearching] = useState(false);
	const [error, setError] = useState(null);
	const requestIdRef = useRef(0);
	const isReferenceSearch = enabled && isAlertReferencePrefix(value);

	useEffect(() => {
		const requestId = ++requestIdRef.current;
		setError(null);

		if (!isReferenceSearch) {
			setResults(null);
			setIsSearching(false);
			return undefined;
		}

		setIsSearching(true);
		const timeoutId = setTimeout(() => {
			alertService.searchByReference(value, closed, (err, response) => {
				if (requestId !== requestIdRef.current) return;

				setIsSearching(false);
				if (err || !Array.isArray(response)) {
					setResults(null);
					setError(err || new Error("Invalid alert reference search response"));
					return;
				}
				setResults(response);
			});
		}, SEARCH_DEBOUNCE_MS);

		return () => clearTimeout(timeoutId);
	}, [closed, enabled, isReferenceSearch, value]);

	return { error, isReferenceSearch, isSearching, results };
};

export default useAlertReferenceSearch;
